import type BoundsUtil from "../../boundsUtil";
import type MatrixUtil from "../../matrixUtil";
import type { GeomTypeUtil } from "./geomTypeUtil";
import type LS from "./LS";

/**
 * Geometry functions for multi point
 */
export default class MT implements GeomTypeUtil {
    private boundsUtil: BoundsUtil;
    private matrixUtil: MatrixUtil;
    private LS: LS;

    constructor(boundsUtil: BoundsUtil, matrixUtil: MatrixUtil, LS: LS) {
        this.boundsUtil = boundsUtil;
        this.matrixUtil = matrixUtil;
        this.LS = LS;
    }

    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractPoints(geom: any[], callback: Function, owner?: any) {
        this.LS.extractPoints(geom, callback, owner);
    }
    
    /**
     * 
     * @param geom 
     * @param callback 
     * @param owner 
     */
    extractLines(geom: any[], callback: Function, owner?: any) {
        const line = [0,0,0,0];
        for (let g = geom.length; g-- > 1;) {
            line[1] = line[3] = geom[g--];
            line[0] = line[2] = geom[g];

            callback.call(owner, line, 0, 4);
        }
    }
    
    /**
     * 
     * @param geom 
     * @param bounds 
     * 
     * @returns 
     */
    getBounds(geom: any[], bounds: number[]): number[] {
        return this.boundsUtil.valueOf(geom, bounds, 1);
    }

    /**
     * 
     * @param geom 
     * @param matrix 
     * 
     * @returns 
     */
    transform(geom: any[], matrix: any[]): any[] {
        return this.matrixUtil.transform(matrix, geom, 1, geom.length, ["MT"]);
    }
    
    /**
     * 
     * @param geom 
     * @param threshold 
     * 
     * @returns 
     */
    generalize(geom: any[], threshold: number): any[] {
        return geom;
    }
}
